// extracted by mini-css-extract-plugin
export default {"input":"SearchInput_input__b76Rx","error":"SearchInput_error__lu0G3","searchWrapper":"SearchInput_searchWrapper__6rQee","searchIcon":"SearchInput_searchIcon__1YUQ4"};